var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","t-data":"profile-image"}},[_c('v-img',{attrs:{"src":_vm.thumbnail,"max-height":"502"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }